var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',_vm._l((this.list),function(li){return _c('p',{key:li.text},[(typeof li == 'object')?_c('a',{attrs:{"href":li.url,"target":"_blank"}},[_vm._v(_vm._s(li.text))]):_c('span',[_vm._v(" "+_vm._s(li)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }